<template>
  <div class="my_form">
    <el-dialog
    title="请假明细"
      :visible.sync="visible"
      width="1000px"
      top='20vh'
      :before-close="onClose">
      <PTable :columns="columns" :loadData="loadData" ref="table" :showSize="false" />
      <span slot="footer" class="dialog-footer">
      </span>
    </el-dialog>
  </div>
</template>

<script>
import PTable from '@/components/PTable';
export default {
  props: {
    visible: {
      type: Boolean,
      required: false
    },
    record: {
      type: Array,
      default: () => []
    }
  },
  components: {
    PTable
  },
  data () {
    return {
      columns: [
        {
          label: '基本信息',
          children: [
            {
              label: '序号',
              prop: 'index',
              width: 80,
              fixed: "left"
            },
            {
              label: '姓名',
              prop: 'data32',
              // width: 100
            },
            {
              label: '部门',
              prop: 'data33',
              // width: 100
            }
          ]
        },
        {
          label: '请假明细',
          children: [{
            label: '类型',
            prop: 'holidayName'
          },
          {
            label: '请假开始时间',
            prop: 'startTime',
            width: 180
          },
          {
            label: '请假结束时间',
            prop: 'endTime',
            width: 180
          },
          {
            label: '时长(天)',
            prop: 'duration',
            // width: 100
          }
          ]
        }
      ],
      loadData: () => {
        return new Promise((resolve, reject) => {
            resolve({
              data: {
                totalCount: this.record.length,
                dataList: this.record
              }
            })
        })
      },
      flag:false
    };
  },
  watch: {
    record: {
      handler() {
        if(this.$refs.table) this.$refs.table.refresh(true)
      },
      immediate: true,
      deep:true
    }
  },
  methods: {
    onClose () {
      this.$emit('update:visible', false);
    },
    onDialogClose () {
      // 还好保留一个遮罩，直接移除
      const tag = document.querySelector('.checkList .v-modal');
      if (tag) tag.remove();
    }
  }
};
</script>
